import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { originalEditingBoxTypeSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { shouldShowSuperSpeedBoxLabelSelector } from '../../../../../redux/cart/cart.selectors';
import { BoxCardItemComponent } from './box-card-item';
const propsSelector = (state, props) => props;
export const shouldShowSuperSpeedLabelSelector = createSelector(propsSelector, shouldShowSuperSpeedBoxLabelSelector, ({
  boxTypeItem
}, shouldShowSuperSpeedBoxLabel) => shouldShowSuperSpeedBoxLabel && boxTypeItem.isBoxForSuperSpeed);
const mapStateToProps = createStructuredSelector({
  originalBoxType: originalEditingBoxTypeSelector,
  shouldShowSuperSpeedLabel: shouldShowSuperSpeedLabelSelector
});
export const BoxCardItem = connect(mapStateToProps)(BoxCardItemComponent);